/** Lower rank = higher severity. Unknown values sort last. */
export const severityRank = (severity) => {
  switch (String(severity || "").toLowerCase()) {
    case "critical":
      return 0;
    case "high":
      return 1;
    case "medium":
      return 2;
    case "low":
      return 3;
    default:
      return 4;
  }
};

export const getSeverityBadgeClasses = (severity) => {
  const key = String(severity || "").toLowerCase();

  switch (key) {
    case "critical":
      return "text-red-500 border-red-500";
    case "high":
      return "text-amber-400 border-amber-400";
    case "medium":
      return "text-[#42C83C] border-[#42C83C]";
    case "low":
      return "text-sky-400 border-sky-400";
    default:
      return "text-gray-400 border-gray-500";
  }
};

export const formatSeverityLabel = (severity) => {
  if (!severity) return "Unknown";
  const text = String(severity);
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
